import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NotificationComponent } from './components/notification/notification.component';
import { ThemeService } from './services/theme.service';
import { AuthService } from './services/auth.service';
import { FcmService } from './services/fcm.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NotificationComponent],
  template: `
    <router-outlet></router-outlet>
    <app-notification></app-notification>
  `
})
export class AppComponent implements OnInit {

  constructor(
    private themeService: ThemeService,
    private authService: AuthService,
    private fcmService: FcmService
  ) {}

  ngOnInit(): void {
    // Initialize theme from localStorage
    const savedTheme = localStorage.getItem('theme') as 'light' | 'dark';
    if (savedTheme) {
      this.themeService.setTheme(savedTheme);
    }

    // Initialize FCM only ONCE when authenticated (on initial load only)
    if (this.authService.isAuthenticated() && this.fcmService.isAvailable()) {
      this.fcmService.initializeFCM();
    }
  }
}
